module.exports = __webpack_public_path__ + "static/media/SH 26+text.be8cb4ad.mp3";